import React, { FC, ReactNode } from 'react';

import { styled } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { Link } from 'react-router-dom';

interface CategoryLinkProps {
  to: string;
  children: ReactNode;
}

const CategoryLink: FC<CategoryLinkProps> = (props) => <StyledLink {...props} />;

export default CategoryLink;

const StyledLink = styled(Link)`
  padding: 9px 14px;
  box-sizing: border-box;
  border-radius: 999em;
  font-weight: bold;
  font-size: 14px;
  text-decoration: none;
  color: ${({ theme }) => theme.palette.common.text.white};
  line-height: 1;
  background-color: ${({ theme }) => theme.palette.common.subcategories};
  transition: background-color 0.3s;

  &:hover {
    background-color: ${({ theme }) => alpha(theme.palette.common.subcategories, 0.3)};
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: 16px;
    padding: 9px 19px;
  }
`;
